import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxPaginationModule} from 'ngx-pagination';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPermissionsModule} from 'ngx-permissions';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {RouterModule} from '@angular/router';
import {LoadingModule} from 'ngx-loading';
import {CommonModule} from '@angular/common';

import {routes} from './editype.routing';
import {EditypeComponent} from "./editype.component";

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    NgxDatatableModule,
    LoadingModule,
    NgxPermissionsModule.forChild(),
    NgbModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    EditypeComponent
  ]
})
export class EdiTypeModule{ }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/editype/editype.module.ts